import { PORTAL_ALERTS_REDUCER_KEY } from 'store/portalAlerts/actions'

export const submittingSelector = state => state[PORTAL_ALERTS_REDUCER_KEY].submitLoading
export const modalOpenSelector = state => state[PORTAL_ALERTS_REDUCER_KEY].modalOpen
